import { GameAnalytics } from '../../analytics/GameAnalytics';
import { AnalyticsEventNames } from '../../analytics/AnalyticsEventNames';
import { showMessagePopUp } from '../../utils/GameEngine';

export enum ProductID {
    noAdsPass = '001'
}

export interface IAPProduct {
    description: string;
    imageURI: string;
    price: string;
    priceAmount: number;
    priceCurrencyCode: string;
    productID: string;
    title: string;
}

export interface Purchase {
    developerPayload: any;
    isConsumed: boolean;
    paymentActionType: string;
    paymentID: string;
    productID: string;
    purchasePlatform: string;
    purchasePrice: { amount: string, currency: string };
    purchaseTime: number;
    purchaseToken: string;
    signedRequest: string;
}

export class IAPManager {
    private static _instance: IAPManager;

    private _IAPAvailable: boolean = false;
    private paymentsReady: boolean = false;

    constructor() {
        const supportedAPIs: string[] = FBInstant.getSupportedAPIs();
        if (supportedAPIs.indexOf('payments.purchaseAsync') > -1) {
            this._IAPAvailable = true;
        }
        FBInstant.payments.onReady((): void => {
            this.paymentsReady = true;
            FBInstant.payments.getPurchasesAsync().then((purchases: Purchase[]) => {
                purchases.forEach((item: Purchase) => {
                    if (item.productID === ProductID.noAdsPass && item.isConsumed === false) {
                        FBInstant.payments.consumePurchaseAsync(item.purchaseToken).then(() => {
                            console.log('Item ' + item.purchaseToken + ' consumed!');
                        }).catch((error: Error) => {
                            console.log(error.message);
                        });
                    }
                });
            });
        });
    }

    public static getInstance(): IAPManager {
        return this._instance || (this._instance = new this());
    }

    public get IAPAvailable(): boolean {
        return this._IAPAvailable && this.paymentsReady;
    }

    public async attemptPurchase(productID: ProductID, onSuccess: () => any, onFail: (err: Error) => any): Promise<void> {
        const productAvailable: boolean = await this.checkIfProductAvailable(productID);
        console.log(productAvailable);
        if (productAvailable) {
            GameAnalytics.getInstance().logDesign(AnalyticsEventNames.no_ads_purchase_attempt, true, true);
            FBInstant.payments.purchaseAsync({
                productID: productID,
                developerPayload: null,
            }).then((purchase: Purchase) => {
                FBInstant.payments.consumePurchaseAsync(purchase.purchaseToken).then(() => {
                    onSuccess();
                    GameAnalytics.getInstance().logDesign(AnalyticsEventNames.no_ads_purchase_success, true, true);
                }).catch((error: Error) => {
                    console.log(error.message);
                });
            }).catch((error: any) => {
                onFail(error);
                GameAnalytics.getInstance().logDesign(AnalyticsEventNames.no_ads_purchase_fail, true, true, null, error.message);
                if (error.code !== 'USER_INPUT') {
                    showMessagePopUp('Sorry, this operation is not supported');
                }
            });
        }
    }

    private async checkIfProductAvailable(productID: ProductID): Promise<boolean> {
        let available: boolean = false;
        await FBInstant.payments.getCatalogAsync().then((catalog: IAPProduct[]) => {
            console.log(catalog);
            catalog.forEach((product: IAPProduct) => {
                if (product.productID === productID) {
                    available = true;
                }
            });
        });
        return available;
    }
}